import React from 'react';

const PartnerInformation = () => {
    return <div />;
};

export default PartnerInformation;
